var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showFormDialog
    ? _c(
        "v-dialog",
        {
          staticClass: "custom-fields-form-dialog",
          attrs: { width: "800", "hide-overlay": "" },
          model: {
            value: _vm.showFormDialog,
            callback: function ($$v) {
              _vm.showFormDialog = $$v
            },
            expression: "showFormDialog",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.closeFormDialog,
                  expression: "closeFormDialog",
                },
              ],
              staticClass: "form-content",
            },
            [
              _c("div", { staticClass: "form-title-container" }, [
                _c("span", { staticClass: "form-title" }, [
                  _vm._v(_vm._s(_vm.typeOfFieldToRenderInForm)),
                ]),
              ]),
              _c("span", { staticClass: "required-fields-advice" }, [
                _vm._v(
                  _vm._s(_vm.$t("components.form_generator.required_fields"))
                ),
              ]),
              _c("FormGeneratorComponent", {
                attrs: {
                  schema: _vm.schema,
                  fieldValues: _vm.formData,
                  context: _vm.context,
                  formTag: "customFieldsFormDialog",
                },
              }),
              _c("LfActionsBarComponent", {
                staticClass: "action-buttons",
                attrs: { buttons: _vm.buttons, showKebabMenu: false },
                on: { "execute-action": _vm.executeAction },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }